import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSigilContext } from '../../context/sigilContext';

const Footer = () => {
    const { i18n } = useSigilContext();
    const menuTranslate = i18n?.menu || [];

    return (
        <Box 
            component="footer" 
            sx={{
                width: '100%',
                padding: '24px',
                marginTop: 'auto', // Asegura que quede al fondo
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                gap: 2
            }}
        >
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: { xs: 2, md: 4 }
            }}>
                <Link to="/info" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', '&:hover': { color: 'white' }}}>
                        {menuTranslate.length > 2 ? menuTranslate[2] : '¿Qué es un sigilo?'}
                    </Typography>
                </Link>
                <Link to="/forum" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', '&:hover': { color: 'white' }}}>
                        {menuTranslate.length > 5 ? menuTranslate[5] : 'Foro de la Comunidad'}
                    </Typography>
                </Link>
                <Link to="/grimoire" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', '&:hover': { color: 'white' }}}>
                        {menuTranslate.length > 6 ? menuTranslate[6] : 'El Grimorio'}
                    </Typography>
                </Link>
                <Link to="/faq" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', '&:hover': { color: 'white' }}}>
                        {menuTranslate.length > 7 ? menuTranslate[7] : 'FAQ'}
                    </Typography>
                </Link>
                <Link to="/about" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', '&:hover': { color: 'white' }}}>
                        {menuTranslate.length > 3 ? menuTranslate[3] : 'Acerca de'}
                    </Typography>
                </Link>
                <Link to="/policy" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', '&:hover': { color: 'white' }}}>
                        {i18n?.policy?.title || 'Política de Privacidad'}
                    </Typography>
                </Link>
                <Link to="/coffee" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', '&:hover': { color: 'white' }}}>
                        {menuTranslate.length > 4 ? menuTranslate[4] : 'Invítame un café'}
                    </Typography>
                </Link>
            </Box>
            
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.3)', marginTop: 2 }}>
                © {new Date().getFullYear()} Magia del Caos. Todos los derechos reservados.
            </Typography>
        </Box>
    );
};

export default Footer;
